import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const SuccessMetrics = () => {
  const trustPoints = [
    {
      id: 1,
      icon: "Scale",
      label: "Zugelassene Rechtsanwälte",
      description: "Alle Berater sind bei der Rechtsanwaltskammer zugelassene Anwälte",
      color: "text-primary"
    },
    {
      id: 2,
      icon: "Shield",
      label: "Anwaltliche Schweigepflicht",
      description: "Absolute Vertraulichkeit gemäß berufsrechtlicher Vorschriften",
      color: "text-trust-builder"
    },
    {
      id: 3,
      icon: "Lock",
      label: "DSGVO-konform",
      description: "Datenschutzkonforme Verarbeitung aller persönlichen Daten",
      color: "text-accent"
    },
    {
      id: 4,
      icon: "Phone",
      label: "24/7 Verfügbarkeit",
      description: "Rund um die Uhr erreichbar für dringende Rechtsfragen",
      color: "text-conversion-accent"
    },
    {
      id: 5,
      icon: "Euro",
      label: "Transparente Preise",
      description: "Minutengenaue Abrechnung zu 2,99 €/Min – keine versteckten Kosten",
      color: "text-primary"
    },
    {
      id: 6,
      icon: "Award",
      label: "Berufsrechtliche Standards",
      description: "Einhaltung aller Vorschriften der BRAO und der Berufsordnung",
      color: "text-accent"
    }
  ];

  return (
    <section id="success-metrics" className="py-16 bg-gradient-to-br from-muted to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Unsere Qualitätsmerkmale
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Verlässliche Fakten, die unsere Kompetenz und Zuverlässigkeit in der telefonischen Rechtsberatung belegen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trustPoints?.map((point, index) => (
            <motion.div
              key={point?.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl p-6 shadow-professional hover:shadow-elevated transition-all duration-300 border border-slate-200"
            >
              <div className="flex items-center mb-4">
                <div className={`p-3 rounded-lg bg-opacity-10 ${point?.color?.replace('text-', 'bg-')}`}>
                  <Icon
                    name={point?.icon}
                    size={24}
                    className={point?.color}
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 className="text-lg font-semibold text-text-primary mb-1">
                  {point?.label}
                </h3>
              </div>

              <div className="text-text-secondary text-sm">
                {point?.description}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessMetrics;